import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import { Global, css } from '@emotion/core';

var CssBaseline = function CssBaseline(_ref) {
  var styles = _ref.styles;
  return /*#__PURE__*/React.createElement(Global, {
    styles: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\thtml {\n\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t}\n\t\t\thtml,\n\t\t\tbody {\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t\t*,\n\t\t\t*::before,\n\t\t\t*::after {\n\t\t\t\tbox-sizing: inherit;\n\t\t\t}\n\t\t\tstrong,\n\t\t\tb {\n\t\t\t\tfont-weight: bolder;\n\t\t\t}\n\t\t\tbody {\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\tbody.modal--opened {\n\t\t\t\toverflow-y: hidden;\n\t\t\t}\n\t\t\t", "\n\t\t"])), styles)
  });
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default CssBaseline;